export const environment = {
  production: false,
  apiUrl: 'https://apiv2.satel.sa',
  // apiUrl: 'http://localhost:3000',
  mapId: '3c6e39db7bce2b46',
  mapBoxToken: 'pk.eyJ1IjoiYWtpbGFoNyIsImEiOiJjbHpyYjFoMHkwMW5jMmhxMnlsenJxYXJ0In0.ZQs41wLkSUoA_iI50h4W5g',
  googleMapsApiKey: 'AIzaSyBCGp4vt2gq30V_fPN5ikP6hTVoNCM5MMU',
  googleBusinessPlaceId: 'ChIJJW_371UDLz4RKs19jjsMyzE',
  minReviewRating: 4,
  maxReviewsToShow: 6,
  googleReviewsCacheTtlMs: 21600000,
  firebase: {
    projectId: "satel-sa",
    appId: "1:1031450608105:web:99446e7f6a11a8330a4b78",
    storageBucket: "satel-sa.firebasestorage.app",
    apiKey: "AIzaSyBys8S9wxJ6WLoQgRMteFRwg9Z7xKBHsrI",
    authDomain: "satel-sa.firebaseapp.com",
    messagingSenderId: "1031450608105",
    measurementId: "G-KLPB7P95PN"
  }
}
